var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / General / Help"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.9917C18 14.41 14.4183 17.9917 10 17.9917C5.58172 17.9917 2 14.41 2 9.9917C2 5.57342 5.58172 1.9917 10 1.9917C14.4183 1.9917 18 5.57342 18 9.9917ZM8.75 7.9917C8.75 7.77838 8.82016 7.44171 9.00865 7.17993C9.1696 6.95638 9.44444 6.7417 10 6.7417C10.5556 6.7417 10.8304 6.95638 10.9913 7.17993C11.1798 7.44171 11.25 7.77838 11.25 7.9917C11.25 8.20502 11.1798 8.54168 10.9913 8.80347C10.8304 9.02702 10.5556 9.2417 10 9.2417C9.58579 9.2417 9.25 9.57749 9.25 9.9917V11.4917C9.25 11.9059 9.58579 12.2417 10 12.2417C10.4142 12.2417 10.75 11.9059 10.75 11.4917V10.6553C11.4019 10.4962 11.8837 10.1313 12.2087 9.67993C12.6202 9.10838 12.75 8.44505 12.75 7.9917C12.75 7.53835 12.6202 6.87502 12.2087 6.30347C11.7696 5.69368 11.0444 5.2417 10 5.2417C8.95556 5.2417 8.2304 5.69368 7.79135 6.30347C7.37984 6.87502 7.25 7.53835 7.25 7.9917C7.25 8.40591 7.58579 8.7417 8 8.7417C8.41421 8.7417 8.75 8.40591 8.75 7.9917ZM10.75 13.9917C10.75 14.4059 10.4142 14.7417 10 14.7417C9.58579 14.7417 9.25 14.4059 9.25 13.9917C9.25 13.5775 9.58579 13.2417 10 13.2417C10.4142 13.2417 10.75 13.5775 10.75 13.9917Z",
    fill: "#858E99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpGray);
export default __webpack_public_path__ + "static/media/help-gray.7f890221f388a668356a645239b12cd7.svg";
export { ForwardRef as ReactComponent };